/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DidCommMessageBlobAttachmentDescriptor } from './DidCommMessageBlobAttachmentDescriptor';

export const DidCommMessageBlobDescriptor: core.serialization.ObjectSchema<
    serializers.DidCommMessageBlobDescriptor.Raw,
    Truvity.DidCommMessageBlobDescriptor
> = core.serialization.object({
    attachments: core.serialization.list(DidCommMessageBlobAttachmentDescriptor),
    blobId: core.serialization.property('blob_id', core.serialization.string()),
    createdAt: core.serialization.property('created_at', core.serialization.date()),
    from: core.serialization.string(),
    id: core.serialization.string(),
    thid: core.serialization.string().optional(),
    to: core.serialization.string(),
    uploadUri: core.serialization.property('upload_uri', core.serialization.string()),
});

export declare namespace DidCommMessageBlobDescriptor {
    export interface Raw {
        attachments: DidCommMessageBlobAttachmentDescriptor.Raw[];
        blob_id: string;
        created_at: string;
        from: string;
        id: string;
        thid?: string | null;
        to: string;
        upload_uri: string;
    }
}
